import { InfoOutlined } from '@mui/icons-material';
import { defaultReminderConfiguration, reminderConfigurationSchema } from '@procureai/schemas';
import {
  FormWidgetI18nConfig,
  ReminderConfigurationForm,
  ReminderConfigurationFormProps,
  SimpleFormWidget,
  SimpleFormWidgetConfigProps,
} from '@procureai/ui-modules-mui';
import { z } from 'zod';

import { I18nNamespace } from '~/common/types';

import { useNegotiationReminderSettingsWidgetBackend } from './NegotiationReminderSettingsWidget.hooks.tsx';

const reminderWidgetSchema = z.object({ reminderConfiguration: reminderConfigurationSchema });
type ReminderFormData = z.infer<typeof reminderWidgetSchema>;

const config: SimpleFormWidgetConfigProps<ReminderFormData> = {
  schema: reminderWidgetSchema,
  defaultValues: { reminderConfiguration: defaultReminderConfiguration },
  iconComponent: InfoOutlined,
};

const i18n: FormWidgetI18nConfig = {
  ns: I18nNamespace.widgets,
  keyPrefix: 'NegotiationReminderSettingsWidget',
};

const slotProps: Required<Pick<ReminderConfigurationFormProps, 'slotProps'>> = {
  slotProps: {},
};

export const NegotiationReminderSettingsWidget = () => {
  return (
    <SimpleFormWidget<ReminderFormData>
      {...config}
      useBackend={useNegotiationReminderSettingsWidgetBackend}
      intercomTarget={i18n.keyPrefix}
      i18n={i18n}
    >
      {(props) => <ReminderConfigurationForm {...props} slotProps={slotProps.slotProps} />}
    </SimpleFormWidget>
  );
};
